import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';

import { RegisterCountryPageRoutingModule } from './register-country-routing.module';
import { RegisterCountryPage } from './register-country.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, RegisterCountryPageRoutingModule, ComponentsModule],
  declarations: [RegisterCountryPage]
})
export class RegisterCountryPageModule {}
